import { render, staticRenderFns } from "./PointTiers.vue?vue&type=template&id=3fcd4913&scoped=true"
import script from "./PointTiers.vue?vue&type=script&lang=js"
export * from "./PointTiers.vue?vue&type=script&lang=js"
import style0 from "./PointTiers.vue?vue&type=style&index=0&id=3fcd4913&prod&lang=css"
import style1 from "./PointTiers.vue?vue&type=style&index=1&id=3fcd4913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcd4913",
  null
  
)

export default component.exports